import axios from 'axios';

const mine = (data) => axios.get('/custom/brief/mine', data);
const save = (data) => axios.post('/custom/brief/saveOrUpdate', data);
const del = (data) => axios.post('/custom/brief/delete', data); //delete

export default {
  mine,
  save,
  del,
}


